import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SinglePaymentComponent } from './containers/single-payment/single-payment.component';
import { ResultComponent } from './containers/result/result.component';
import { PendingComponent } from './containers/pending/pending.component';
import { LegacyGuard } from './guards/legacy-guard.service';
import { ErrorComponent } from './containers/error/error.component';
import { RedirectGuard } from './guards/redirect.guard';
import { CancelledComponent } from './containers/cancelled/cancelled.component';
import { CancelledPaidComponent } from './containers/cancelled-paid/cancelled-paid.component';
import { PaymentResolver } from './resolvers/payment.resolver';
import { PaymentTypeResolver } from './resolvers/payment-type.resolver';
import { OnlyBalanceResolver } from './resolvers/only-balance.resolver';
import { WireTransferComponent } from './containers/wire-transfer/wire-transfer.component';
import { CardPaymentComponent } from './containers/card-form/card-payment.component';
import { PersonalDataResolver } from './resolvers/personal-data.resolver';
import { MaintenanceComponent } from './containers/maintenance/maintenance.component';

const routes: Routes = [
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [LegacyGuard],
    component: ErrorComponent
  },
  {
    path: '',
    children: [
      {
        path: ':token',
        component: SinglePaymentComponent,
        data: { typeToggleVisible: true },
        canActivate: [RedirectGuard],
        resolve: {
          payment: PaymentResolver,
          paymentType: PaymentTypeResolver,
          onlyBalance: OnlyBalanceResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
      },
      {
        path: ':token/wire-transfer',
        component: WireTransferComponent,
        canActivate: [RedirectGuard],
        resolve: {
          payment: PaymentResolver,
          paymentType: PaymentTypeResolver
        }
      },
      {
        path: ':token/card-payment',
        component: CardPaymentComponent,
        canActivate: [RedirectGuard],
        resolve: {
          paymentType: PaymentTypeResolver,
          personalData: PersonalDataResolver
        },
        data: {
          headerPaymentSummaryVisible: true
        }
      },
      {
        path: ':token/pending',
        component: PendingComponent,
        canActivate: [RedirectGuard],
        resolve: {
          payment: PaymentResolver,
          paymentType: PaymentTypeResolver
        }
      },
      {
        path: ':token/result',
        component: ResultComponent,
        canActivate: [RedirectGuard],
        resolve: {
          payment: PaymentResolver,
          paymentType: PaymentTypeResolver
        }
      },
      {
        path: ':token/error',
        component: ErrorComponent
      },
      {
        path: ':token/cancelled',
        component: CancelledComponent,
        canActivate: [RedirectGuard],
        resolve: {
          payment: PaymentResolver,
          paymentType: PaymentTypeResolver
        }
      },
      {
        path: ':token/cancelled-paid',
        component: CancelledPaidComponent,
        canActivate: [RedirectGuard],
        resolve: {
          payment: PaymentResolver,
          paymentType: PaymentTypeResolver
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
